// generated file
// generated file
// generated file

import "primeflex/primeflex.min.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";

import * as React from "react";

export interface ThemeProviderProps {
  theme: string;
  replaceColors: boolean;
  children?: any;
}

const getThemeProvider = ({ theme, replaceColors }: ThemeProviderProps) => {
  if (replaceColors && theme === "lara-dark-purple") {
    return React.lazy(
      () => import("./lara-dark-purple/themeWithColorsReplaced")
    );
  }

  if (replaceColors && theme === "lara-light-purple") {
    return React.lazy(
      () => import("./lara-light-purple/themeWithColorsReplaced")
    );
  }

  if (theme === "lara-dark-purple") {
    return React.lazy(() => import("./lara-dark-purple/theme"));
  }

  if (theme === "lara-light-purple") {
    return React.lazy(() => import("./lara-light-purple/theme"));
  }

  return React.lazy(() => import("./lara-light-purple/theme"));
};

export const ThemeProvider = ({
  theme,
  replaceColors,
  children,
}: ThemeProviderProps) => {
  const _ThemeProvider = React.useMemo(
    () => getThemeProvider({ theme, replaceColors }),
    [theme]
  );

  return <_ThemeProvider>{children}</_ThemeProvider>;
};

export const getThemeList = () => {
  return [
    {
      themeName: "lara-dark-purple",
      path: "primereact/resources/themes/lara-dark-purple/theme.css",
    },

    {
      themeName: "lara-light-purple",
      path: "primereact/resources/themes/lara-light-purple/theme.css",
    },
  ];
};

export interface ThemeVariablesListEntry {
  themeName: string;
  getModule: () => Promise<any>;
}
export const getThemeVariables = (): ThemeVariablesListEntry[] => {
  return [
    {
      themeName: "lara-dark-purple",
      getModule: () => import("./lara-dark-purple/theme-variables"),
    },

    {
      themeName: "lara-light-purple",
      getModule: () => import("./lara-light-purple/theme-variables"),
    },
  ];
};
